import { Link } from "react-router-dom";
import { brandStats, testimonials } from "@/mocks/gossip";

export default function TrustBand() {
  return (
    <section aria-labelledby="trust-title" className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase mb-2">
            <span className="w-4 h-px bg-primary-500"></span>
            Why Us
          </span>
          <h2 id="trust-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-balance">
            为什么大家愿意在这里吃瓜
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            我们不追标题党，只做一件事：把现场的原始画面整理清楚。
            每一段视频都标注来源分类、时长与发布时间，让你在点开之前就知道自己要看的是什么。
          </p>

          <dl className="mt-8 grid grid-cols-2 gap-5">
            {brandStats.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <dt className="text-xs text-foreground-500">{stat.label}</dt>
                <dd className="mt-1.5 font-heading text-2xl font-bold text-accent-600">{stat.value}</dd>
              </div>
            ))}
          </dl>

          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {testimonials.map((item) => (
              <figure key={item.name} className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-double-quotes-l w-5 h-5 flex items-center justify-center"></i>
                </span>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">{item.quote}</blockquote>
                <figcaption className="mt-4 border-t border-background-300 pt-3">
                  <span className="block font-heading text-sm font-semibold text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}